// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment-drop-zone {
  display: flex;
  min-height: 96px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #b8c2cc;
  border-radius: 6px;
  background-color: #f8f9fa;
  color: #495057;
  text-align: center;
  transition: border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}

.attachment-drop-zone.is-drag-over {
  border-color: #0d6efd;
  background-color: #e9f2ff;
  color: #0a58ca;
}

.attachment-drop-zone.is-disabled {
  opacity: 0.65;
}

.attachment-drop-zone-title {
  font-weight: 600;
}

.attachment-drop-zone-subtitle {
  margin-top: 4px;
  font-size: 0.875rem;
}

.attachment-file-actions,
.attachment-dialog-actions,
.attachment-row-actions {
  gap: 12px;
}

.btn::after {
  content: none !important;
  display: none !important;
}

.attachment-actions-cell {
  width: 1%;
  white-space: nowrap;
  text-align: center;
}

.attachment-action-button {
  display: inline-flex;
  min-width: 104px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid transparent;
}

.attachment-action-button mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
}

.attachment-download-button {
  border-color: #006fba;
  background-color: #006fba;
  color: #fff;
}

.attachment-download-button:hover,
.attachment-download-button:focus-visible {
  border-color: #00558f;
  background-color: #00558f;
  color: #fff;
}

.attachment-open-button {
  border-color: #006fba;
  background-color: #fff;
  color: #006fba;
}

.attachment-open-button:hover,
.attachment-open-button:focus-visible {
  background-color: #e8f3fa;
  color: #00558f;
}

.attachment-delete-button {
  border-color: #b42318;
  background-color: #b42318;
  color: #fff;
}

.attachment-delete-button:hover,
.attachment-delete-button:focus-visible {
  border-color: #8f1c13;
  background-color: #8f1c13;
  color: #fff;
}

.attachment-action-button:disabled {
  border-color: #ced4da;
  background-color: #e9ecef;
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/test-attachments-dialog/test-attachments-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".attachment-drop-zone {\n  display: flex;\n  min-height: 96px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #b8c2cc;\n  border-radius: 6px;\n  background-color: #f8f9fa;\n  color: #495057;\n  text-align: center;\n  transition: border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease;\n}\n\n.attachment-drop-zone.is-drag-over {\n  border-color: #0d6efd;\n  background-color: #e9f2ff;\n  color: #0a58ca;\n}\n\n.attachment-drop-zone.is-disabled {\n  opacity: 0.65;\n}\n\n.attachment-drop-zone-title {\n  font-weight: 600;\n}\n\n.attachment-drop-zone-subtitle {\n  margin-top: 4px;\n  font-size: 0.875rem;\n}\n\n.attachment-file-actions,\n.attachment-dialog-actions,\n.attachment-row-actions {\n  gap: 12px;\n}\n\n.btn::after {\n  content: none !important;\n  display: none !important;\n}\n\n.attachment-actions-cell {\n  width: 1%;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.attachment-action-button {\n  display: inline-flex;\n  min-width: 104px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid transparent;\n}\n\n.attachment-action-button mat-icon {\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n  line-height: 18px;\n}\n\n.attachment-download-button {\n  border-color: #006fba;\n  background-color: #006fba;\n  color: #fff;\n}\n\n.attachment-download-button:hover,\n.attachment-download-button:focus-visible {\n  border-color: #00558f;\n  background-color: #00558f;\n  color: #fff;\n}\n\n.attachment-open-button {\n  border-color: #006fba;\n  background-color: #fff;\n  color: #006fba;\n}\n\n.attachment-open-button:hover,\n.attachment-open-button:focus-visible {\n  background-color: #e8f3fa;\n  color: #00558f;\n}\n\n.attachment-delete-button {\n  border-color: #b42318;\n  background-color: #b42318;\n  color: #fff;\n}\n\n.attachment-delete-button:hover,\n.attachment-delete-button:focus-visible {\n  border-color: #8f1c13;\n  background-color: #8f1c13;\n  color: #fff;\n}\n\n.attachment-action-button:disabled {\n  border-color: #ced4da;\n  background-color: #e9ecef;\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
